<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DATA_EXTC_TYPE_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_TYPE_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctTypeData.dataExtractionTypeName"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              name="button"
              class="btn_innerTbl_border"
              @click="onClickSearch"
            >
              {{ $t('MSG_BTN_SEARCH') }}
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctTypeData.moduleName"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="dataExctTypeData.subModuleName"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="dataExctTypeData.dataExtractionContent"
              :readonly="true"
            />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MASS_EXTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-radio
              v-model="dataExctTypeData.dataExtractionBigQuantityYn"
              :disabled="true"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="dataExctTypeData.dataExtractionBigQuantityYn"
              :disabled="true"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_BAT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctTypeData.batchJobId"
              :readonly="true"
            />
          </div>
        </div> -->
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctTypeData.dataExtractionStandardValue"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_LIMIT_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctTypeData.dataExtractionRestrictionPeriod"
              :readonly="true"
              mask="number"
              maxlength="4"
            />
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DATA_EXTC_RQS_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_REQ_DATE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-date-picker
              ref="dpExtractionRequestStartDT"
              v-model="dataExctRequestData.dataExtractionRequestStartDT"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-site-select
              ref="siteSelect"
              :defaultOption="'select'"
              :pageId="pageId"
              :selected="dataExctRequestData.dataExtractionRequestSiteId"
              :initialSelectedKey="this.$store.getters.userInfo.siteId"
              :disabled="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_START_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-date-picker
              ref="dpExtractionStartDT"
              v-model="dataExctRequestData.dataExtractionStartDT"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_END_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-date-picker
              ref="dpExtractionEndDT"
              v-model="dataExctRequestData.dataExtractionEndDT"
            />
          </div>
        </div>
        <!--
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="추출 사업장" :vertical="false" />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionSiteId"
              :readonly="true">
            </sui-text-field>
            <div class="comp_spacing"></div>
            <sui-button type="button" name="button" class="btn_innerTbl_border">검색</sui-button>
          </div>
        </div>
-->
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionRequestStandardValue"
              maxlength="112"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_RSN')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="dataExctRequestData.dataExtractionRequestContent"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMS_00012'"
        type="button"
        class="comm_btn_solid"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SUBM') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00012_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00012',
    },
    selectedGridRowData: {
      type: Object,
      default() { return {}; },
    },
  },
  data() {
    return {
      dataExctTypeData: {
        dataExtractionTypeUid: '',
        dataExtractionTypeName: '',
        moduleCode: '',
        subModuleCode: '',
        moduleName: '',
        subModuleName: '',
        dataExtractionContent: '',
        dataExtractionBigQuantityYn: '',
        batchJobId: '',
        dataExtractionStandardValue: '',
        dataExtractionRestrictionPeriod: '',
      },
      dataExctRequestData: {
        dataExtractionRequestStartDT: '',
        dataExtractionStartDT: '',
        dataExtractionEndDT: '',
        dataExtractionRequestStandardValue: '',
        dataExtractionRequestContent: '',
        dataExtractionRequestSiteId: {
          key: '',
          label: '',
        },
      },

    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClickSearch() {
      utils.openLayerPopup('PGE_CMS_00011', this.onPagePopupCallback, {
        pageInitialData: {},
        size: 'lg',
      });
    },
    onPagePopupCallback(selectedData) {
      if (selectedData) {
        const selectedRowData = utils.clone(selectedData[0]);
        // TextField mask 'number' 사용 시 int Type으로 넣으면 에러 발생하여 String으로 변환.
        selectedRowData.dataExtractionRestrictionPeriod = selectedRowData.dataExtractionRestrictionPeriod.toString();

        this.dataExctTypeData = selectedRowData;
        this.dataExctRequestData.dataExtractionRequestStandardValue = this.dataExctTypeData.dataExtractionStandardValue;
      }
    },
    validationCheck() {
      if (!this.dataExctTypeData.dataExtractionTypeUid) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DATA_EXTC_TYPE_INFO'));
        utils.messageBox('warning', msg);
        return false;
      }

      if (!this.dataExctRequestData.dataExtractionRequestStartDT) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_REQ_DATE'));
        utils.messageBox('warning', msg);
        return false;
      }

      if (this.dataExctRequestData.dataExtractionStartDT > this.dataExctRequestData.dataExtractionEndDT) {
        const msg = this.$t('MSG_ALT_ABLE_START_DT_PREC_FINS_DT');
        utils.messageBox('warning', msg);
        return false;
      }

      const startDt = utils.dateformatToServer(this.dataExctRequestData.dataExtractionStartDT);
      const endDt = utils.dateformatToServer(this.dataExctRequestData.dataExtractionEndDT);
      const dayOffset = utils.getDayOffset(endDt, startDt);

      if (dayOffset > utils.parseInt(this.dataExctTypeData.dataExtractionRestrictionPeriod)) {
        const msg = this.$t('MSG_ALT_ABLE_EXTC_DT');
        utils.messageBox('warning', msg);
        return false;
      }

      if (!this.dataExctRequestData.dataExtractionRequestContent) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RQS_RSN'));
        utils.messageBox('warning', msg);
        return false;
      }
      return true;
    },
    onSaveClick() {
      // if (!this.dataExctTypeData.dataExtractionTypeUid) {
      //   const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DATA_EXTC_TYPE_INFO'));
      //   utils.messageBox('warning', msg);
      //   return false;
      // }

      // if (!this.dataExctRequestData.dataExtractionRequestStartDT) {
      //   const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_REQ_DATE'));
      //   utils.messageBox('warning', msg);
      //   return false;
      // }

      // if (this.dataExctRequestData.dataExtractionStartDT > this.dataExctRequestData.dataExtractionEndDT) {
      //   const msg = this.$t('MSG_ALT_ABLE_START_DT_PREC_FINS_DT');
      //   utils.messageBox('warning', msg);
      //   return false;
      // }

      // const startDt = utils.dateformatToServer(this.dataExctRequestData.dataExtractionStartDT);
      // const endDt = utils.dateformatToServer(this.dataExctRequestData.dataExtractionEndDT);
      // const dayOffset = utils.getDayOffset(endDt, startDt);

      // if (dayOffset > utils.parseInt(this.dataExctTypeData.dataExtractionRestrictionPeriod)) {
      //   const msg = this.$t('MSG_ALT_ABLE_EXTC_DT');
      //   utils.messageBox('warning', msg);
      //   return false;
      // }

      // if (!this.dataExctRequestData.dataExtractionRequestContent) {
      //   const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RQS_RSN'));
      //   utils.messageBox('warning', msg);
      //   return false;
      // }
      if (!this.validationCheck()) return false;
      // date picker validation
      if (this.onClickValidate()) return false;

      this.personInChargeList();

      return null;
    },
    /* 상신 서비스 */
    saveService(aprvData) {
      const requestData = {};
      const startDt = utils.dateformatToServer(this.dataExctRequestData.dataExtractionRequestStartDT, 'S');
      requestData.dataExtractionTypeUid = this.dataExctTypeData.dataExtractionTypeUid;
      requestData.dataExtractionRequestStartDT = startDt;
      requestData.dataExtractionRequestStandardValue = `${this.dataExctRequestData.dataExtractionRequestStandardValue
      } startDt=${utils.dateformatToServer(this.dataExctRequestData.dataExtractionStartDT, 'S')
      } endDt=${utils.dateformatToServer(this.dataExctRequestData.dataExtractionEndDT, 'S')
      } siteId=${this.dataExctRequestData.dataExtractionRequestSiteId.key}`;
      requestData.dataExtractionRequestContent = this.dataExctRequestData.dataExtractionRequestContent;

      // 결재 상신 정보
      if (!utils.isEmpty(aprvData)) {
        utils.assign(requestData, { approvalData: aprvData });
      }

      http.request(this.pageId, 'DTS_CMS_00043', {
        data: requestData,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SUBMITTED_APRV'));
        this.$emit('close');
      });
    },
    onCancelClick() {
      this.$emit('close');
    },
    /* 결재 상신 팝업 */
    onAprvClick(personInChargeList) {
      const objTemplate = {
        templateId: 'TMP_CMS_DATA_EXTC_APRV',
        siteId: this.dataExctRequestData.dataExtractionRequestSiteId.key,
        langId: this.$store.getters.userInfo.langId,
        dataExtractionTypeName: this.dataExctTypeData.dataExtractionTypeName,
        moduleCode: this.dataExctTypeData.moduleName,
        subModuleCode: this.dataExctTypeData.subModuleName,
        dataExtractionContent: this.dataExctTypeData.dataExtractionContent,
        requestUser: this.$store.getters.userInfo.userName, // 요청자
        requestDtm: this.dataExctRequestData.dataExtractionRequestStartDT, // 요청일
        dataExtractionRequestContent: this.dataExctRequestData.dataExtractionRequestContent, // 요청사유
        tcdmDqIfList: [{
          moduleCode: 'CM',
          STND_CODE: '11',
          TGT_SYSTEM: 'cdmSysKey',
          DQ_IF_DATE: '',
          DQ_IF_TIME: '',
          KEY_FIELD_1: '',
          KEY_FIELD_2: '',
          KEY_FIELD_3: '',
          KEY_FIELD_4: '',
          KEY_FIELD_5: '',
          DEL_YN_FLAG: '',
          FIELD_S01: '',
          FIELD_S02: '',
          FIELD_S03: '',
          FIELD_S04: '',
          FIELD_S05: '',
          FIELD_S06: '',
          FIELD_S07: '',
          FIELD_S08: '',
          FIELD_S09: '',
          FIELD_S10: '',
          FIELD_L01: '',
          FIELD_L02: '',
          FIELD_L03: '',
          FIELD_L04: '',
          FIELD_L05: '',
          DESC_EN: '',
          DESC_KO: '',
          DESC_CN: '',
        },
        {
          STND_CODE: '22',
          TGT_SYSTEM: '2Rows',
          DQ_IF_DATE: '',
          DQ_IF_TIME: '',
          KEY_FIELD_1: '',
          KEY_FIELD_2: '',
          KEY_FIELD_3: '',
          KEY_FIELD_4: '',
          KEY_FIELD_5: '',
          DEL_YN_FLAG: '',
          FIELD_S01: '',
          FIELD_S02: '',
          FIELD_S03: '',
          FIELD_S04: '',
          FIELD_S05: '',
          FIELD_S06: '',
          FIELD_S07: '',
          FIELD_S08: '',
          FIELD_S09: '',
          FIELD_S10: '',
          FIELD_L01: '',
          FIELD_L02: '',
          FIELD_L03: '',
          FIELD_L04: '',
          FIELD_L05: '',
          DESC_EN: '',
          DESC_KO: '',
          DESC_CN: '',
        }],
      };

      utils.openLayerPopup('PGE_CMZ_00012', this.aprvPopupCallback, {
        pageInitialData: {
          // 필수: 업무코드, 업무결재Id
          taskId: 'TSK_CM001006',
          taskApprovalId: 'uid',

          // 결재 제목
          title: `[G-EHS] ${this.dataExctTypeData.dataExtractionTypeName}`,
          titleReadonly: true,

          // 결재 Route
          // 선택:담당자그룹Id로 결재자 조회시 사용
          // picGroupId: 'PIC_CMS_DATA_EXTC',
          aprvUsers: personInChargeList,
          popupRoutesModify: false,
          knoxRoutesModify: false,

          // 선택: 첨부파일 DocId
          // attachDocumentId: [],
          //* 결제에 첨부파일을 등록할경우 모듈 코드 값이 필수
          // moduleCode: 'CM',

          attachModify: false,
          // 결재본문
          objTemplate,
          contentsModify: false,

        },
        size: 'xlg',
      });
    },
    aprvPopupCallback(objAprv) {
      if (utils.isEmpty(objAprv) === false) {
        this.saveService(objAprv);
        // 업무 param
        // const dataparam = {};

        // 업무쪽 Param 객체에 결제데이터를 적용
        // TODO : ApprovalCOMMDVO를 상속 받았을경우
        // utils.assign(dataparam, this.aprvData);

        // TODO : ApprovalCOMMDVO를 approvalData 변수로 받을경우
        // utils.assign(dataparam, { approvalData: this.aprvData });

        // 이후 프로세스 진행
      }
    },
    personInChargeList() {
      http.request(this.pageId, 'DTS_CMZ_00136', {
        path: {
          'pic-type-id': this.dataExctTypeData.picTypeId,
        },
        query: {
          picGroupingSiteId: this.dataExctRequestData.dataExtractionRequestSiteId.key,
          picGroupingCodeValidityValue1: this.dataExctTypeData.moduleCode,
          picGroupingCodeValidityValue2: this.dataExctTypeData.subModuleCode,
        },
      }).then(res => {
        const personInChargeList = [];
        utils.forEach(res.data, obj => {
          const userInfo = {
            userId: obj.userId,
            aprvCode: obj.rightApprovalCode,
          };
          personInChargeList.push(userInfo);
        });
        this.onAprvClick(personInChargeList);
      });
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dpExtractionRequestStartDT.isValid()
        || !this.$refs.dpExtractionStartDT.isValid()
        || !this.$refs.dpExtractionEndDT.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
